module.exports = __webpack_public_path__ + "media/app/assets/profile-default-188e80b9322a64b1957e665c7fa20e08.png";